import contentService from '@/services/http/content/ContentService'

export const CollectionModule = () => {
  return {
    namespaced: true,
    state: {
      status: 'empty', // empty | idle | updating
      collection: [],
    },
    mutations: {
      SET_COLLECTION (state, data) {
        state.data = data
      },
      SET_ENTRY (state, data) {
        state.collection = [...state.collection, data]
      },
      SET_STATUS (state, status) {
        state.status = status
      }
    },
    actions: {
      fetchCollection ({ commit }, data) {
        commit('SET_COLLECTION', data)
      },
      async fetchEntry ({ commit, state, getters }, {collection, slug}) {
        commit('SET_STATUS', startFetch(state))
        const data = await contentService.fetchFromCms(collection, slug)
        commit('SET_ENTRY', data)
        commit('SET_STATUS', endFetch(state))
        return data
      }
    },
    getters: {
      getEntry: (state) => (slug) => {
        return state.collection.find(entry => entry.slug === slug)
      }
    }
  }
}

const startFetch = (state) => {
  if (state.collection.length < 1) {
    return 'empty'
  }
  return 'updating'
}

const endFetch = (state) => {
  if (state.collection.length < 1) {
    return 'empty'
  }
  return 'idle'
}
